export default __webpack_public_path__ + "static/media/rw.2c4523c0.svg";